import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Toaster } from "@/components/ui/sonner";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#060606] text-white selection:bg-[var(--gold)] selection:text-black">
      <Navbar />
      <main data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <Toaster richColors theme="dark" position="bottom-right" />
    </div>
  );
};

export default Layout;
